import { RouteRecordRaw } from 'vue-router';

export default {
  path: '/material',
  name: 'material',
  redirect: '/material/product',
  component: () => import('@/layout/index.vue'),
  meta: {
    title: 'menus.material',
    icon: 'el-icon-documentCopy',
    sort: 2
  },
  children: [
    {
      path: '/material/product',
      name: 'material_product',
      component: () => import('@/views/material/product/index.vue'),
      meta: {
        title: 'menus.materialProduct',
        icon: 'el-icon-box'
      }
    },
    {
      path: '/material/detail',
      name: 'material_detail',
      component: () => import('@/views/material/product/detail.vue'),
      meta: {
        title: 'menus.materialProductEdit',
        isMenu: false
      }
    },
    {
      path: '/material/file',
      name: 'material_file',
      component: () => import('@/views/material/file/index.vue'),
      meta: {
        title: 'menus.materialFile',
        icon: 'el-icon-files'
      }
    },
    {
      path: '/material/brochure',
      name: 'material_brochure',
      component: () => import('@/views/material/brochure/index.vue'),
      meta: {
        title: 'menus.materialBrochure',
        icon: 'el-icon-notebook'
      }
    },
    {
      path: '/material/brochureDetail',
      name: 'material_brochure_detail',
      component: () => import('@/views/material/brochure/detail.vue'),
      meta: {
        title: 'menus.materialBrochureEdit',
        isMenu: false
      }
    },
    {
      path: '/material/case',
      name: 'material_case',
      component: () => import('@/views/material/case/index.vue'),
      meta: {
        title: 'menus.materialCase',
        icon: 'el-icon-trendCharts'
      }
    },
    {
      path: '/material/caseDetail',
      name: 'material_case_detail',
      component: () => import('@/views/material/case/detail.vue'),
      meta: {
        title: 'menus.materialCaseEdit',
        isMenu: false
      }
    },
    {
      path: '/material/video',
      name: 'material_video',
      component: () => import('@/views/material/video/index.vue'),
      meta: {
        title: 'menus.materialVideo',
        icon: 'el-icon-videoPlay'
      }
    },
    {
      path: '/material/videoDetail',
      name: 'material_video_detail',
      component: () => import('@/views/material/video/detail.vue'),
      meta: {
        title: 'menus.materialVideoEdit',
        isMenu: false
      }
    },
    {
      path: '/material/poster',
      name: 'material_poster',
      component: () => import('@/views/material/poster/index.vue'),
      meta: {
        title: 'menus.materialPoster',
        icon: 'el-icon-Picture'
      }
    },
    {
      path: '/material/posterDetail',
      name: 'material_poster_detail',
      component: () => import('@/views/material/poster/detail.vue'),
      meta: {
        title: 'menus.materialPosterEdit',
        isMenu: false
      }
    },
    {
      path: '/material/article',
      name: 'material_article',
      component: () => import('@/views/material/article/index.vue'),
      meta: {
        title: 'menus.materialArticle',
        icon: 'el-icon-Tickets'
      }
    },
    {
      path: '/material/dynamic',
      name: 'material_dynamic',
      component: () => import('@/views/material/dynamic/index.vue'),
      meta: {
        title: 'menus.materialDynamic',
        icon: 'el-icon-Tickets'
      }
    },
    {
      path: '/material/dynamicDetail',
      name: 'material_dynamic_detail',
      component: () => import('@/views/material/dynamic/detail.vue'),
      meta: {
        title: 'menus.materialDynamicEdit',
        isMenu: false
      }
    },
    {
      path: '/material/articleDetail',
      name: 'material_article_detail',
      component: () => import('@/views/material/article/detail.vue'),
      meta: {
        title: 'menus.materialArticleEdit',
        isMenu: false
      }
    },
    {
      path: '/material/configCategory',
      name: 'material_configCategory',
      component: () => import('@/views/material/configCategory/index.vue'),
      meta: {
        title: 'menus.materialConfigCategory',
        icon: 'el-icon-Setting'
      }
    }
  ]
} as RouteRecordRaw;
